import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import CustomTextarea from '../../CustomTextarea';

export const ModalRejectRequestId = 'ModalRejectRequest';

const ModalRejectRequest = ({ mediaIsPhone, onClick, modalClose }) => {
  const scrollableAreaRef = useRef(null);
  const [comment, setComment] = useState();

  return (
    <Modal
      title="Rifiuta la richiesta"
      mb={32}
      modalId={ModalRejectRequestId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{ minWidth: 'min(60vw, 560px)' }}
      >
        <Text type="b3" mb={31}>
          Aggiungi un commento
        </Text>
        <CustomTextarea
          onChange={(v) => setComment(v)}
          id="reject-request-textarea"
        />
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="conferma"
          fullsize={mediaIsPhone}
          disabled={!comment}
          onClick={() => {
            onClick(comment);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalRejectRequest.propTypes = {
  onClick: PropTypes.func,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state

  // dispatch
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      return {};
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
    })
  ),
  withMediaQueries
)(ModalRejectRequest);
